export const getConfirmedPurchaseInformation = (state) => state.entities.users.confirmedSubscription;
